/* ============================================
   No Lo Busques Más – Carrusel de banners
   Cada banner recibe --offset (-1 izquierda, 0 centro, 1 derecha) y el CSS
   lo ubica. El carrusel da la vuelta: después del último vuelve al primero.
   ============================================ */
if (!customElements.get('nlbm-banner-carousel')) {
  class NlbmBannerCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-banner-index]'));
      this.dots = Array.from(this.querySelectorAll('[data-banner-dot]'));
      if (!this.slides.length) return;

      this.current = 0;
      this.timer = null;
      this.hovered = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.render(true);
      this.bindEvents();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    offsetFor(index) {
      var count = this.slides.length;
      var offset = (index - this.current + count) % count;
      if (offset > count / 2) offset -= count;
      /* Con 2 banners, el otro siempre queda a la derecha */
      if (count === 2 && offset < 0) offset = 1;
      return offset;
    }

    render(initial) {
      var self = this;
      this.slides.forEach(function (slide, i) {
        var offset = self.offsetFor(i);
        var previous = slide.dataset.offset === undefined ? offset : parseInt(slide.dataset.offset, 10);
        /* Si un banner cruza de un lado al otro, se mueve sin animación para que no pase por delante */
        slide.classList.toggle('no-transition', initial || Math.abs(offset - previous) > 1);
        slide.style.setProperty('--offset', offset);
        slide.dataset.offset = offset;
        slide.classList.toggle('is-active', offset === 0);
        slide.classList.toggle('is-far', Math.abs(offset) > 1);
        slide.setAttribute('tabindex', offset === 0 ? '0' : '-1');
        slide.setAttribute('aria-hidden', Math.abs(offset) > 1 ? 'true' : 'false');
      });
      this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === self.current);
        dot.setAttribute('aria-current', i === self.current ? 'true' : 'false');
      });
      /* Se vuelve a activar la animación en el próximo cuadro */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          self.slides.forEach(function (slide) {
            slide.classList.remove('no-transition');
          });
        });
      });
    }

    goTo(index) {
      var count = this.slides.length;
      this.current = ((index % count) + count) % count;
      this.render(false);
      this.restartAutoplay();
    }

    bindEvents() {
      var self = this;
      var prev = this.querySelector('[data-banner-prev]');
      var next = this.querySelector('[data-banner-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.current - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.current + 1); });

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.goTo(parseInt(dot.dataset.bannerDot, 10));
        });
      });

      /* Deslizar con el dedo; si fue un deslizamiento, no se abre el enlace */
      var startX = 0;
      var startY = 0;
      var swiped = false;
      this.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].clientX;
        startY = e.changedTouches[0].clientY;
        swiped = false;
      }, { passive: true });
      this.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          self.goTo(self.current + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
      this.addEventListener('click', function (e) {
        if (swiped) {
          e.preventDefault();
          swiped = false;
        }
      }, true);

      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.goTo(self.current - 1);
        if (e.key === 'ArrowRight') self.goTo(self.current + 1);
      });

      /* Se frena mientras el mouse está encima */
      this.addEventListener('mouseenter', function () {
        self.hovered = true;
        self.stopAutoplay();
      });
      this.addEventListener('mouseleave', function () {
        self.hovered = false;
        self.startAutoplay();
      });
    }

    startAutoplay() {
      if (this.getAttribute('data-autoplay') !== 'true' || this.reducedMotion || this.hovered) return;
      if (this.slides.length < 2 || (window.Shopify && window.Shopify.designMode)) return;
      this.stopAutoplay();
      var self = this;
      var seconds = parseInt(this.getAttribute('data-autoplay-speed'), 10) || 5;
      this.timer = setInterval(function () {
        self.current = (self.current + 1) % self.slides.length;
        self.render(false);
      }, seconds * 1000);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('nlbm-banner-carousel', NlbmBannerCarousel);
}
